/**
 * Truncates a string to the specified length and appends "..." if needed.
 * @param {string} text - The text to truncate.
 * @param {number} maxLength - The maximum allowed length of the text.
 * @returns {string} The truncated text with ellipsis if applicable.
*/

export const TruncateText = (text, maxLength) => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};
